import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import Log from '../../models/Log';


export interface LogDetailState extends ApiState {
  log?: Log
}

export default requestReducer<LogDetailState>('LOG_DETAIL')
